import React, { useState, useRef, useEffect } from 'react';
import API_REST from '../../../api-rest-uruk';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Auth } from 'aws-amplify';
import useWindowSize from '../../../customHooks/useWindowSize';
import ScreenWithGrids from './ScreenWithGrids';
import ScreenWithDialog from './ScreenWithDialog';
import LoadingCard from '../../UI/LoadingCard';
import { useTranslation } from 'react-i18next';

const CreateFlow = (props) => {
  const { match, config, currentRole } = props;
  const { t } = useTranslation();

  const documentId = match.params.number;

  const windowSize = useWindowSize();
  const formRef = useRef(null);
  const history = useHistory();

  const [templateId, setTemplateId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    async function getUser () {
      let currentUser;
      try {
        currentUser = await Auth.currentAuthenticatedUser();
      } catch (err) {
        console.log(err);
        window.location.reload();
      }
      setUser(currentUser);
    }
    getUser();
  }, []);

  const onSubmit = async (formData) => {
    setLoading(true);
    const body = {
      documentId,
      templateId,
      formData: {
        ...formData,
        currentUserUsername: user.username,
        currentUserEmail: user.signInUserSession.idToken.payload.email,
        currentUserRol: currentRole,
        currentUserPhone: user.signInUserSession.idToken.payload.phone_number
      } };

    API_REST.createFlow(body)
      .then((res) => {
        history.push('/file');
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  return (
    <>
      <LoadingCard open={loading} loading message={t('fileCreateFlow:creatingFlow')} />
      {windowSize.width >= 760 ? (
        <ScreenWithGrids
          config={config}
          onSubmit={onSubmit}
          documentId={documentId}
          loading={loading}
          formRef={formRef}
          setTemplateId={setTemplateId}
        />
      ) : (
        <ScreenWithDialog
          config={config}
          onSubmit={onSubmit}
          documentId={documentId}
          loading={loading}
          formRef={formRef}
          setTemplateId={setTemplateId}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.config,
    currentRole: state.config.currentRole
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateFlow);
